export default {
    OnlyCurrent: 'OnlyCurrent',
    AllFuture: 'AllFuture'
};
